import { Immutable } from "immer";
import React from "react";

import { EditorContent } from "@thelabnyc/thelabui/src/components/EditorContent";

import { IMenuFooter } from "./menu.interface";

type IProps = Immutable<{
    navFooterEl: IMenuFooter;
}>;

export const NavFooter = (props: IProps) => {
    return (
        <div className="main-dropdown-menu__footer l-full-width">
            <EditorContent>
                {(marker) => (
                    <div
                        className="l-capped-width"
                        dangerouslySetInnerHTML={{
                            __html: props.navFooterEl.value.html,
                        }}
                        {...marker}
                    ></div>
                )}
            </EditorContent>
        </div>
    );
};
